function renderWishlistCounter(swat) {
    // Get the element with id 'wishlist-counter'
    var counter_elem = document.getElementById("wishlist-counter");
    
    if (counter_elem) { // Ensure the element exists
        // Check if swat and its method renderWishlistCount exist
        if (swat && typeof swat.renderWishlistCount === 'function') {
            swat.renderWishlistCount(counter_elem);
            counter_elem.style.display = "block"; // Show the counter element
        }
    }
}

// Add the function to SwymCallbacks
if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}
window.SwymCallbacks.push(renderWishlistCounter);
